import {useCallback, useState} from 'react';
import Link from '@mui/material/Link';
import type {JSONValue} from 'types';
import type {ProblemConstraintViolation} from 'api/http/types';
import {useLocalization} from 'localization';
import {AlertDialog} from 'components/alertdialog';
import {Layout} from 'components/layout';
import {PrettyPrintJson} from 'components/prettyPrintJson';
import {Spacer} from 'components/spacer';
import {Text} from 'components/text';
import type {SnackBodyWithErrorDetailsProps} from '../types';

export const SnackBodyWithErrorDetails: React.FC<
  SnackBodyWithErrorDetailsProps
> = ({message, error, closeSnack}) => {
  const {t} = useLocalization();
  const [isOpen, setIsOpen] = useState(false);
  const handleCloseDialog = useCallback(() => {
    setIsOpen(false);
    closeSnack();
  }, [closeSnack]);

  const problemError =
    error && error.info
      ? (error?.info as unknown as ProblemConstraintViolation).violations
        ? (error.info as unknown as ProblemConstraintViolation)
        : (error.info as unknown as JSONValue)
      : undefined;

  return (
    <Layout horizontal adjustCenter>
      <Text variant="body2">{message}</Text>
      <Spacer size={2} />
      <Link onClick={() => setIsOpen(true)} sx={{cursor: 'pointer'}}>
        {t('error.details.label')}
      </Link>
      <AlertDialog
        isOpen={isOpen}
        title={t('error.details.title')}
        body={<PrettyPrintJson json={problemError ?? {}} />}
        onConfirm={() => Promise.resolve(handleCloseDialog())}
        onCancel={() => undefined}
      />
    </Layout>
  );
};
